import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bindPromiseCreators } from 'redux-saga-routines';

import { fetchRolesRoutine, saveRoleRoutine, removeRolePromise } from '../../../../redux/routines';
import { showDialog, hideDialog } from '../../../../redux/actions/dialogs';
import Dashboard from '../../../Dashboard/index';
import RoleDialog from '../RoleDialog/index';
import { toJS } from '../../../../utils/helper';

import { isDialogVisibleSelector } from '../../../../redux/selectors';
import { ROLE_DIALOG } from '../../../../redux/constants/dialogs';
import RolesGrid from '../RolesGrid/index';

class RolesView extends Component {

  render() {
    const { isDialogVisible, roles, fetchRoles, showDialog, removeRole } = this.props;

    return (
      <Dashboard title="Roles">
        <RolesGrid
          data={roles}
          fetch={fetchRoles}
          showDialog={showDialog}
          onRemove={removeRole}
        />

        {isDialogVisible(ROLE_DIALOG) ? <RoleDialog/> : null}
      </Dashboard>
    );
  }
}

RolesView.propTypes = {
  fetchRoles: PropTypes.func.isRequired,
  saveRole: PropTypes.func.isRequired,
  removeRole: PropTypes.func.isRequired,
  data: PropTypes.object,

  showDialog: PropTypes.func.isRequired,
  hideDialog: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    roles: toJS(state.getIn(['roles', 'roles'])),
    isDialogVisible: isDialogVisibleSelector(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      fetchRoles: fetchRolesRoutine.trigger,
      saveRole: saveRoleRoutine.trigger,
      showDialog,
      hideDialog,
    }, dispatch),
    ...bindPromiseCreators({
      removeRole: removeRolePromise,
    }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RolesView);



// WEBPACK FOOTER //
// ./src/components/Admin/Roles/RolesView/index.js